namespace SP {
    export interface ArrivalInfo {
        arrivalId: string;
        arrivalSender: string;
        arrivalSenderReferenceNo: string;
        arrivalReferenceNo: string;
        arrivalTimestamp: number;
        arrivalDate: string;
        arrivalTime: string;
        arrivalType: ArrivalType;
        arrivalFinished: boolean;
        arrivalLocation: string;
        customerId: string;
        stockName: string;
        createUserName: string;
        purchaseOrderInfo: purchaseOrderInfo;
        purchaseOrderId: number;
        itemsArrived: number;
        itemsExpected: number;
    }
}